import * as yup from 'yup';

const companyNameSchema = () => (
  yup.object().shape(
    {
      company_name: yup.string()
        .required('Company name is Required')
        .matches(/^[aA-zZ\s\d]+$/, "Only letters and numbers are allowed")
        .max(20, 'Must be less than or equal to 20 characters long')
        .min(6,  'Must be at least 6 characters long')
    }
  )
)

export default companyNameSchema